export default "__VITE_ASSET__143d0b9e__"